export const getNumberFormat = ({ locale, number, options = {} }) => new Intl.NumberFormat(locale, options).format(number);
